module.exports = __webpack_public_path__ + "img/footer-qr-code-wechat.7c20ff94.png";